Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Modal3781226971",
  {"modal":"Modal3781226971--modal","overlay":"Modal3781226971--overlay","closeButtonWrapper":"Modal3781226971--closeButtonWrapper","root":"Modal3781226971--root"},
  "",
  1,
  "Modal3781226971"
);

